// import Swiper JS
import Swiper, {
  Pagination,
  Autoplay,
  EffectFade,
  Navigation,
  Scrollbar,
} from "swiper";
import SimpleBar from "simplebar"; // or "import SimpleBar from 'simplebar';" if you want to use it manually.
import "simplebar/dist/simplebar.css";
// import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

import "swiper/css/effect-fade";
import "swiper/css/autoplay";
import "swiper/css/scrollbar";

const bannerSlider = document.getElementById("banner-slider");
const calendarHomeWrapper = document.getElementById("calendar-home-wrapper");
const cesde_time_line_container = document.getElementById(
  "cesde_time_line_container"
);
if (bannerSlider) {
  const bannerswiper = new Swiper("#banner-slider", {
    modules: [Pagination, EffectFade, Autoplay],
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },

    loop: true,
    autoplay: {
      delay: 5000,
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
  });
}
if (cesde_time_line_container) {
  const timeLineSwiper = new Swiper("#cesde_time_line_container", {
    modules: [Navigation],
    navigation: {
      nextEl: ".time-line-next",
      prevEl: ".time-line-prev",
    },
    slidesPerView: 1,

    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px

      0: {
        slidesPerView: 1,
      },
      // when window width is >= 640px
      1025: {
        slidesPerView: 2,
      },
    },
  });
}
if (document.getElementById("sedes-swiper")) {
  const sedesHomeSwiper = new Swiper("#sedes-swiper", {
    modules: [Navigation],
    navigation: {
      nextEl: ".sedes-button-next",
      prevEl: ".sedes-button-prev",
    },
    slidesPerView: 5,

    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px

      0: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 2,
      },
      991: {
        slidesPerView: 3,
      },
      // when window width is >= 640px
      1020: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 5,
      },
    },
  });
}

if (calendarHomeWrapper) {
  const calendarSimpleScroll = new SimpleBar(
    document.getElementById("calender-home-content"),
    {
      autoHide: false,
      forceVisible: "y",
      ariaLabel: "Calendario cesde",
    }
  );
}
if (document.getElementById("cesde_calendar_carousel")) {
  const cesdeCalendarCarousel = new Swiper("#cesde_calendar_carousel", {
    modules: [Autoplay, Navigation],
    // loop: true,
    autoplay: {
      delay: 5000,
    },
    navigation: {
      nextEl: ".calendar-button-next",
      prevEl: ".calendar-button-prev",
    },
    slidesPerView: 1,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
    },
  });
}
//cesde_escuela_carousel
if (document.getElementById("cesde_escuela_carousel")) {
  const cesdeEscuelaCarousel = new Swiper("#cesde_escuela_carousel", {
    modules: [Autoplay, Navigation],
    // loop: true,
    autoplay: {
      delay: 5000,
    },
    navigation: {
      nextEl: ".escuela_carousel-button-next",
      prevEl: ".escuela_carousel-button-prev",
    },
    slidesPerView: 3,
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 2,
      },
      1025: {
        slidesPerView: 3,
        autoplay: false,
      },
    },
  });
}
if (document.getElementById("reglamento-carousel")) {
  const reglamentoCarousel = new Swiper("#reglamento-carousel", {
    modules: [Autoplay, Pagination, Navigation],
    pagination: {
      el: ".reglamento-pagination",
      type: "bullets",
      clickable: true,
    },
    // loop: true,
    autoplay: {
      delay: 5000,
    },
    navigation: {
      nextEl: ".reglamento-button-next",
      prevEl: ".reglamento-button-prev",
    },
    slidesPerView: 3,
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 2,
      },
      1025: {
        slidesPerView: 3,
        autoplay: false,
      },
    },
  });
}
if (document.getElementById("payments-sliders")) {
  const paymentsSliders = new Swiper("#payments-sliders", {
    modules: [Autoplay, Navigation],
    // loop: true,
   
    navigation: {
      nextEl: ".payments-methods-button-next",
      prevEl: ".payments-methods-button-prev",
    },
    slidesPerView: 1,
    breakpoints: {
      1200: {
        slidesPerView: 2,
      },
    },
  });
  const paymentsheight = document.getElementById("payments-sliders").clientHeight
  const slideMethods = document.querySelectorAll('.slide-method')
  slideMethods.forEach(slideMethod=>{
    slideMethod.style.minHeight = `${paymentsheight}px`
  })
}
if(document.getElementById('lumnis-sliders')){
  const lumnisSliders = new Swiper('#lumnis-sliders',{
    modules: [Autoplay, Navigation],
   
 
    navigation: {
      nextEl: ".lumnis-beneficios-button-next",
      prevEl: ".lumnis-beneficios-button-prev",
    },
    slidesPerView: 3,
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 2,
      },
      1025: {
        slidesPerView: 3,
       
      },
    },
  })
  const lumniheight = document.getElementById("lumnis-sliders").clientHeight
  const slidelumnis = document.querySelectorAll('.slider-lumni .lumni-wrapper')
  slidelumnis.forEach(slidelumni=>{
    slidelumni.style.minHeight = `${lumniheight}px`
  })
}

if(document.getElementById('cesde_payment_channelswiper')){
 console.log('first')
}
